export default __webpack_public_path__ + "static/founders-grotesk-regular-255b6c6a7b70a28ed7a700e84e6ff87e.eot";